import { useState } from "react";

function MailTester() {
  const [mail, setMail] = useState(null);

  const fetchMail = async () => {
    console.log("🔎 Fetching latest mail...");
    const res = await fetch("http://localhost:5000/fetch-latest");
    const data = await res.json();
    setMail(data);
    console.log("✅ Latest mail:", data);
  };

  const sendReply = async () => {
    if (!mail || !mail.messageId) {
      alert("⚠️ No mail fetched yet!");
      return;
    }

    console.log("📤 Sending reply...");
    await fetch("http://localhost:5000/send-reply", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        messageId: mail.messageId,
        recipient: mail.from,
      }),
    });

    alert("✅ Reply sent!");
  };

  return (
    <div style={{ padding: "20px", fontFamily: "Arial" }}>
      <h2>📧 Mail Tester</h2>
      <button onClick={fetchMail}>Fetch Latest Mail</button>

      {mail && (
        <div style={{ marginTop: "20px" }}>
          <p><b>From:</b> {mail.from}</p>
          <p><b>Subject:</b> {mail.subject}</p>
          <p><b>Text:</b> {mail.text}</p>
          <button onClick={sendReply}>Reply with PDF</button>
        </div>
      )}
    </div>
  );
}

export default MailTester;
